import { render, staticRenderFns } from "./dataDisplay.vue?vue&type=template&id=99d9448e&scoped=true&"
import script from "./dataDisplay.vue?vue&type=script&lang=js&"
export * from "./dataDisplay.vue?vue&type=script&lang=js&"
import style0 from "./dataDisplay.vue?vue&type=style&index=0&id=99d9448e&prod&lang=scss&"
import style1 from "./dataDisplay.vue?vue&type=style&index=1&id=99d9448e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d9448e",
  null
  
)

export default component.exports